import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M24,6.25A3,3,0,1,0,19.74,9c-.47,1.38-1.53,3.79-3.24,3.79-2.3,0-3-3.14-3.53-6.17a3,3,0,1,0-1.94,0c-.56,3.09-1.24,6.17-3.53,6.17-1.71,0-2.77-2.41-3.24-3.79a3,3,0,1,0-2.13.15l1.63,9.8a1,1,0,0,0,1,.84h14.5a1,1,0,0,0,1-.84l1.63-9.8A3,3,0,0,0,24,6.25Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M19.25,21.25H4.75a1,1,0,0,0,0,2h14.5a1,1,0,0,0,0-2Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }